'use strict';
define('settings',[],function () {
	var gameData = {
		local: {
			configUrl: 'config.json',
			template: 'modern',
			currencyMap: {
				TSh: '',
				TT$: '$',
				Rs: '₨',
				Ꝑ: 'руб'
			},
			changeSpeed: 15000,
			logging: {
				consoleLog: true,
				logglyKey: '',
				logglyTags: ['betgames-screen']
			},
			sliding: true,
			slidingDisabled: false,
			jackpotDisplay: 20000,
			jackpotWinDisplay: 10000,
			locale: '',
			staticJackpots: [
				{
					title: 'Promotion to win',
					prize: 'R500 to R1,000'
				}
			]
		},
		games: [],
		versionData: {
			version: null,
			commit: null
		},
		drawingDurations: {
			lucky7: 54,
			lucky6: 45,
			lucky5: 50,
			wheel: 60,
			'rng-wheel': 120,
			'dice-duel': 23
		},
		player: {
			partnerID: '2502',
			lucky7: {
				gameID: 1,
				lowLatency: false
			},
			lucky5: {
				gameID: 3,
				lowLatency: false
			},
			poker: {
				gameID: 5,
				lowLatency: true
			},
			baccarat: {
				gameID: 6,
				lowLatency: true
			},
			wheel: {
				gameID: 7,
				lowLatency: false
			},
			war: {
				gameID: 8,
				lowLatency: false
			},
			lucky6: {
				gameID: 9,
				lowLatency: false
			},
			'dice-duel': {
				gameID: 10,
				lowLatency: true
			},
			'rng-wheel': {
				prerecorded: true
			}
		},
		getGameName: function (gameNo) {
			var game = this.games[gameNo],
				gameConfig = game.config[game.module];

			switch (gameConfig.gameType) {
				case 'rng-wheel':
					return 'wheel';
				case 'dice-duel':
					return 'diceDuel';
				default:
					return gameConfig.gameType;
			}
		},
		convertGameType: function (gameType) {
			switch (gameType) {
				case 'lucky5-offtime':
				case 'lucky6-offtime':
				case 'lucky7-offtime':
					return gameType.replace('-offtime', '');
				default:
					return gameType;
			}
		}
	};

	return gameData;
});

